import React from 'react';

import { FilterType } from 'components/Grid/types';

import { useStore } from 'utils/hooks/store';

import MobileReportsTable from '../MobileReportsTable';
import UsageReportChart from '../UsageReportChart';

import { FilterSelected } from '../UsageReportChart/types';

// oxlint-disable-next-line typescript/no-explicit-any
const MobileTab: React.FC<{ onError: (error: any) => void }> = ({ onError }): React.ReactElement => {
  const { mobileAnalytics } = useStore();

  const refreshRef = React.useRef<(() => void) | null>(null);
  const [filters, setFilters] = React.useState<FilterType[]>([]);

  const updateFilters = (newFilters: FilterSelected[]): void => {
    const filers: FilterType[] = newFilters.map(({ filter, value }) => ({
      field: filter,
      value,
      operator: 'is',
    }));
    setFilters(filers);

    refreshRef.current?.();
  };

  React.useEffect(() => {
    mobileAnalytics.loadData();
  }, []);

  return (
    <>
      <UsageReportChart
        type="mobile"
        deviceAnalytics={mobileAnalytics.deviceAnalytics}
        onUpdateSelected={(newFilters) => updateFilters(newFilters)}
      />
      <MobileReportsTable
        onError={onError}
        filters={filters}
        onRefreshCallback={(callback) => {
          refreshRef.current = callback;
        }}
      />
    </>
  );
};

export default MobileTab;
